import { IllustrationCloseSpace } from "@assets/IllustrationCloseSpace";
import { DoorUnlockPolling } from "@components/Polling/DoorUnlockPolling";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import type { ReactNode } from "react";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

type DoorClosingScreenProps = {
	unlockRequestId: string;
	accessToken?: string;
	header?: ReactNode;
	footer?: ReactNode;
	title?: string;
	description?: string;
	onClosed: () => void;
	onExit?: () => void;
};

export function DoorClosingScreen(props: DoorClosingScreenProps) {
	const { unlockRequestId, accessToken, header, footer, title, description, onClosed, onExit } = props;
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer className="px-6" footer={footer}>
			<div className="-mx-6">{header ?? <AppHeader showHelpButton={true} />}</div>
			<DoorUnlockPolling
				unlockRequestId={unlockRequestId}
				accessToken={accessToken}
				target="closed"
				onExit={onExit}
				onTerminate={(outcome) => {
					// Timeouts and errors are handled inside DoorUnlockPolling (retry panel).
					if (outcome.type === "closed") onClosed();
				}}
			>
				{() => (
					<>
						<h1 className="text-2xl font-breit">
							<T>{title ?? i18n.COLLECT_AND_CLOSE()}</T>
						</h1>
						<p className="text-sm text-muted-foreground">
							<T>{description ?? i18n.COLLECT_AND_CLOSE_DESC()}</T>
						</p>
						<IllustrationCloseSpace />
					</>
				)}
			</DoorUnlockPolling>
		</PageContainer>
	);
}
